import React from "react"
import { Redirect } from "react-router-dom"

import { RoleScreenContent } from "./ScreenContent"
import { useLoginService } from "../../providers/LoginService"

export const RoleProtectedScreenContent = () => {
  const { getAuthTokens } = useLoginService()
  const { authorToken, deliveryToken } = getAuthTokens()
  return !!authorToken && !!deliveryToken ? <RoleScreenContent/> : <Redirect to="/"/>
}
